import {
  Box,
  Button,
  Divider,
  RadioGroup,
  Radio,
  FormControl,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loadAction } from "redux/reducers/top";
import { rem } from "assets/js/common";
import axios from "axios";
import DrawerReceipt from "components/ui/drawer-receipt";
import { useHistory } from "react-router-dom";
import { Cookies } from "react-cookie";

const useStyles = makeStyles((theme) => ({
  shopping: {
    "& .MuiButton-text": {
      fontSize: rem(16),
      width: "100%",
      justifyContent: "flex-start",
    },
    "& .tit": {
      fontWeight: 400,
    },
  },
}));

const cookies = new Cookies();

export default function Shopping(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const [userInfo, setUserInfo] = useState("");
  const [open, setOpen] = useState(false);
  const handleAlertClose = () => {
    setOpen(false);
  };

  let favInfo = cookies.get("favInfo");

  const handleChangeReceipt = async (e) => {
    let checked = e.target.checked;
    // setMblRctYn(checked);
    await axios
      .post("api/mb/member/modify-mobile-receipt", {
        mblRctYn: checked ? "Y" : "N",
      })
      .then((res) => {
        loadUserInfo();
      });
  };

  const handleChangeCashReceipt = async (e) => {
    let checked = e.target.checked;
    // setMblRctYn(checked);
    await axios
      .post("api/mb/mypage/modify-cash-receipt-flag", {
        flag: checked ? 1 : 0,
      })
      .then((res) => {
        loadUserInfo();
      });
  };

  const handleChangePoint = async (e) => {
    console.log("e.target.value", e.target.value);
    await axios
      .post("api/mb/mypage/modify-point-flag", {
        flag: e.target.value,
      })
      .then((res) => {
        loadUserInfo();
      });
  };

  const loadUserInfo = async () => {
    await axios
      .get("api/mb/mypage", {
        params: {
          schTp: favInfo ? favInfo.visibleTp : "1",
          storeCode: favInfo
            ? favInfo.visibleTp === "1"
              ? favInfo.favMt
              : favInfo.favMk
            : "",
        },
      })
      .then((res) => {
        setUserInfo(res.data.data);
        console.log(res.data.data);
      });
  };

  useEffect(() => {
    loadUserInfo();
  }, []);

  window.appBackKeyHandle = () => {
    if (open) {
      handleAlertClose();
    } else {
      history.goBack();
    }
  };

  const { init } = useSelector((state) => state.top);
  useEffect(() => {
    if (init)
      dispatch(loadAction({ back: true, title: "쇼핑정보관리", menu: false }));
  }, [init]);

  return (
    <main id="main" className={"container nopad " + classes.shopping}>
      <div className="setting">
        <Box className="box-type-10">
          <ul className="setting-list shopping-info">
            <li>
              <Link to={"/favorite-store"}>
                <b className="tit">단골매장 설정</b>
              </Link>
            </li>
            <li>
              <Link to={"/mypage/shopping/pay"}>
                <b className="tit">간편결제 등록</b>
              </Link>
            </li>
            <li>
              <div className="recipt">
                <Button onClick={() => setOpen(true)}>
                  <b className="tit">영수증 추후 적립</b>
                </Button>
              </div>
            </li>
            <li>
              <Link to={"/mypage/shopping/point-password"}>
                <b className="tit">포인트 비밀번호 변경</b>
              </Link>
            </li>
            <li>
              <Link to={"/mypage/shopping/cash"}>
                <b className="tit">현금영수증번호 관리</b>
              </Link>
            </li>
          </ul>
        </Box>
        <Divider className="divider-type-2" />

        <Box className="box-type-1">
          <ul className="setting-list">
            <li>
              <b className="tit">모바일 영수증만 발급받기</b>
              <Switch
                inputProps={{ "aria-label": "mobile receipt" }}
                checked={userInfo.mblRctYn == "Y"}
                onChange={handleChangeReceipt}
              />
            </li>
            <li>
              <b className="tit">현금영수증 발급 신청</b>
              <Switch
                inputProps={{ "aria-label": "mobile receipt" }}
                checked={userInfo.cashRctFlag == 1}
                onChange={handleChangeCashReceipt}
              />
            </li>
            <li>
              <b className="tit">포인트 잔돈 결제</b>
              {/* <Switch
                inputProps={{ "aria-label": "mobile receipt" }}
                checked={userInfo.mblRctYn == "Y"}
                onChange={handleChangePoint}
              /> */}
              <FormControl>
                <RadioGroup
                  row
                  value={userInfo.pointFlag || "0"}
                  onChange={handleChangePoint}
                >
                  <FormControlLabel
                    value="0"
                    control={
                      <Radio
                        color="primary"
                        icon={<span className="radio-icon" />}
                        checkedIcon={<span className="radio-icon-checked" />}
                      />
                    }
                    label="항상 확인"
                  />
                  <FormControlLabel
                    value="2"
                    control={
                      <Radio
                        color="primary"
                        icon={<span className="radio-icon" />}
                        checkedIcon={<span className="radio-icon-checked" />}
                      />
                    }
                    label="자동사용"
                  />
                  <FormControlLabel
                    value="9"
                    control={
                      <Radio
                        color="primary"
                        icon={<span className="radio-icon" />}
                        checkedIcon={<span className="radio-icon-checked" />}
                      />
                    }
                    label="미사용"
                  />
                </RadioGroup>
              </FormControl>
            </li>
          </ul>
        </Box>
      </div>

      <DrawerReceipt open={open} handleDrawerClose={handleAlertClose} />
    </main>
  );
}
